"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Licenses_1 = __importDefault(require("./Licenses"));
exports.default = Licenses_1.default;
